import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(issueDetailsCompanyRoute);

    /** @ngInject */
    function issueDetailsCompanyRoute($stateProvider) {
        $stateProvider.state('company_employee.issue_list.details', {
            url: '/szczegoly/:issue_id/',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/details/issue_details.html'),
            controller: 'IssueDetailsCompanyController',
            controllerAs: 'IssueDetailsCompanyCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/issue_details.route.ts